import API from './gasClient';

const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

export const saveOrder = async (pedido, eventId) => {
  try {
    // Gera orderId único com timestamp + random para evitar duplicação
    const timestamp = new Date().getTime();
    const random = Math.random().toString(36).substring(2, 6).toUpperCase();
    const orderId = `PD${timestamp}${random}`;
    
    console.log('💾 Salvando pedido:', orderId);
    // First upload the comprovante to Drive
    let comprovanteUrl = '';
    if (pedido.dadosComprador.comprovante) {
      try {
        const base64Data = await convertFileToBase64(pedido.dadosComprador.comprovante);
        
        // Upload usando a API
        const uploadResponse = await API.uploadFile?.(base64Data, eventId, pedido.dadosComprador.nome);
        
        if (uploadResponse && uploadResponse.success) {
          comprovanteUrl = uploadResponse.fileUrl;
        }
      } catch (uploadError) {
        // Continua sem o comprovante
      }
    }

    // Prepara dados do pedido
    const orderData = {
      orderId,
      eventId,
      comprador: {
        nome: pedido.dadosComprador.nome,
        email: pedido.dadosComprador.email
      },
      participantes: pedido.participantes.map(p => ({
        nome: p.nome,
        unidade: p.unidade || '',
        tipo: p.tipo
      })),
      ingressos: pedido.ingressos,
      total: pedido.total,
      comprovanteUrl,
      data: new Date().toISOString()
    };

    // Save usando a API REST
    const response = await API.saveOrder(orderData);

    if (!response.success) {
      throw new Error(response.error || 'Erro ao salvar pedido');
    }

    // Send confirmation email
    try {
      // Monta estrutura esperada pelo backend
      const emailData = {
        data: {
          to: pedido.dadosComprador.email,
          orderId: orderId,
          pedido: {
            dadosComprador: pedido.dadosComprador,
            participantes: pedido.participantes,
            total: pedido.total
          }
        },
        eventId: eventId
      };
      
      await API.sendEmail(emailData);
    } catch (emailError) {
      // Não falha o pedido se email der erro
    }
    
    return {
      success: true,
      data: response.data,
      comprovanteUrl,
      orderId
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};
